import React from 'react';
import { useArrayFieldItemApi } from '../../hooks/useArrayFieldItemApi.js';

var RemoveButton = function RemoveButton(_ref) {
  var text = _ref.text;
  var _useArrayFieldItemApi = useArrayFieldItemApi(),
    remove = _useArrayFieldItemApi.remove;
  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      remove();
    },
    type: "button"
  }, text ? text : 'Remove');
};

export { RemoveButton };
